export default __webpack_public_path__ + "static/media/crossicon.17620493.svg";